import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./IconButton.css');

// Props
export interface IIconButtonProps {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    labelClassName?: string;
    iconClassName?: string;
    labelOnRight?: boolean;
    showLabel?: boolean;
    label?: string;
    icon?: string;
    removePadding?: boolean;
}

// Component
@observer
export class IconButton extends React.Component<IIconButtonProps, {}> {
    static get defaultProps(): IIconButtonProps {
        return {
            onClick: null,
            className: null,
            labelClassName: null,
            iconClassName: null,
            labelOnRight: false,
            showLabel: false,
            label: '',
            icon: null,
            removePadding: false,
        };
    }

    constructor(props: IIconButtonProps) {
        super(props);
    }

    public render() {
        const {
            className,
            iconClassName,
            labelOnRight,
            showLabel,
            label,
            icon,
            removePadding,
        } = this.props;

        return (
            <button
                onClick={this.props.onClick}
                className={classNames(
                    s.button,
                    {
                        [s.labelOnRight]: labelOnRight,
                        [s.alwaysVisible]: showLabel,
                        [s.noPadding]: removePadding,
                    },
                    className
                )}
            >
                {label && labelOnRight === false && this.renderLabel()}

                {icon && (
                    <span className={classNames(s.icon, iconClassName)}>
                        <img src={icon} />
                    </span>
                )}

                {label && labelOnRight === true && this.renderLabel()}
            </button>
        );
    }

    private renderLabel() {
        return (
            <span className={classNames(s.label, this.props.labelClassName)}>
                {this.props.label}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/IconButton.tsx